import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import FloatingCTAs from "@/components/FloatingCTAs";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LegacyServiceRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/services-luxury-spa/${slug}`} replace />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true, syncTouch: false });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-obsidian text-cream">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us-luxury-spa" element={<About />} />
          <Route path="/services-luxury-spa" element={<Services />} />
          <Route path="/services-luxury-spa/:slug" element={<ServiceDetail />} />
          <Route path="/membership-luxury-spa" element={<Membership />} />
          <Route path="/contact-us-luxury-spa" element={<Contact />} />
          <Route path="/about" element={<Navigate to="/about-us-luxury-spa" replace />} />
          <Route path="/services" element={<Navigate to="/services-luxury-spa" replace />} />
          <Route path="/services/:slug" element={<LegacyServiceRedirect />} />
          <Route path="/membership" element={<Navigate to="/membership-luxury-spa" replace />} />
          <Route path="/contact" element={<Navigate to="/contact-us-luxury-spa" replace />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
        <FloatingCTAs />
      </BrowserRouter>
    </div>
  );
}

export default App;
